import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-per-aziende',
  templateUrl: './per-aziende.component.html',
  styleUrls: ['./per-aziende.component.css']
})
export class PerAziendeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
